import './wdyr';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as Sentry from '@sentry/react';
import { Mixpanel } from 'src/tracking/mixpanel/Mixpanel';
import { Logger } from 'src/utils/Logger';
import Config from 'src/common/Config';
import { ApiError } from 'src/error/ApiError';

const { MODE } = import.meta.env;

function isReportedApiError(originalError: unknown): boolean {
  return originalError instanceof ApiError;
}

Sentry.init({
  dsn: 'https://0d945edb06f746e1a96ebded8f00362f@o4508635414331392.ingest.de.sentry.io/4508733844947024',
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost:8000', /^https:\/\/api\.afternoon\.co\.uk/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  environment: MODE,
  enabled: Config.isProd() || Config.isStaging(),
  release: Config.getReleaseVersion(),
  beforeSend(event, hint) {
    // Prevent re-reporting of ApiErrors by global error handlers
    // (they were already handled by dataProvider)
    if (isReportedApiError(hint.originalException)) {
      return null;
    }

    return event;
  },
});

Mixpanel.initialise();

document.addEventListener('wheel', function () {
  // @ts-expect-error it thinks there's no type
  if (document?.activeElement?.type === 'number') {
    // @ts-expect-error it thinks there's no blur
    document.activeElement.blur();
  }
});

window.addEventListener('error', event => {
  Logger.error('Global error:', event.error);
});

window.addEventListener('unhandledrejection', event => {
  Logger.error('Unhandled promise rejection:', event.reason);
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
